import { logger } from "@/utils/logger"
import { SignIn } from "./signIn.interface"
import { genUser } from "@/testing/data/user"
import { MOCK_API_TIMEOUT } from "@/constants"

export const signInMock: SignIn = async (input) => {
  logger.debug("[Action:Started] Sign in", input)
  return new Promise((res) =>
    setTimeout(() => {
      res([genUser(input.email), null] as const)
    }, MOCK_API_TIMEOUT),
  )
}
